import React, { useEffect, useRef, useState } from 'react'
import { ApiResponse } from 'apisauce'
import { message as notification } from 'antd'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { ButtonTitled } from 'src/components/Ant'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import { Request } from 'src/types'
import api from 'src/services/api'
import download from 'src/helpers/download'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'

interface Props {
  request: Request
}

interface GeneralTravelsProps {
  request: {
    request_number: number
  }
  base64: string
}

export default function RDVButton({ request }: Props) {
  const [loading, setLoading] = useState<boolean>(false)
  const { t } = useTranslation()
  const isSubscribed = useRef(true)

  useEffect(() => {
    return () => {
      isSubscribed.current = false
    }
  }, [])

  return (
    <ButtonTitled
      data-test-id="summary-rdv"
      icon="download"
      loading={loading}
      onClick={async () => {
        try {
          setLoading(true)
          const response: ApiResponse<GeneralTravelsProps> = await api.get(
            `/organizations/${request.organization_id}/requests/${request.request_id}/reports/general_travels`
          )

          if (response.ok) {
            download(
              `data:application/pdf;base64,${response.data.base64}`,
              `travel-expense-report ${
                response.data.request
                  ? response.data.request.request_number || '_'
                  : '_'
              }# ${moment(new Date()).format('YYYYMMDD HHmmss')}.pdf`,
              'application/pdf'
            )

            const message = t(
              'common.push-notifications.generate-rdv-successful'
            )
            notification.success(message, 5)
            return
          }

          const message = findBasicApiResponseErrors(response)
          notification.error(message, 5)
        } catch (err) {
          ClientNotifyCatch('general_travels', err)
          const message = t('common.response.unexpected-error')
          notification.error(message, 5)
        } finally {
          if (isSubscribed.current) {
            setLoading(false)
          }
        }
      }}
      size="default"
      title="web.report.rdv.code"
      tooltip="web.report.rdv.title"
      type="dashed"
    />
  )
}
